import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const ServicesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('300')};
    border-top: 1px solid ${getPurpurColor('gray200')};
    padding-top: ${getPurpurSpacing('600')};
    padding-bottom: ${getPurpurSpacing('600')};
`;

export const ServicesList = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: ${getPurpurSpacing('200')};
`;

type IconContainerProps = {
    $isClickable: boolean;
};
export const IconContainer = styled.div<IconContainerProps>`
    cursor: pointer;
    text-align: center;
    width: 80px;

    &:hover {
        color: ${({ $isClickable }) => $isClickable && getPurpurColor('purple600')};
    }
`;

export const IconText = styled.div`
    font-size: ${getPurpurTypography('scale50')};
`;
